export const Max_Data_Engineers = 1000;
export const Max_Mean_Time_To_Detect = 100;
export const Max_Mean_Time_To_Resolve = 100;
export const Business_Hours_PerYr_PerEngr = 2000;
export const Percent_Hours_To_Detect_After = 1;
export const Avg_Salary = 150000;
// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30Databand = '30B9E';
